import { RootState } from '../store';

export const selectExaminationID = (state: RootState) =>
  state.examinationReducer.examinationID;

export const selectExaminationIDError = (state: RootState) => ({
  error: state.examinationReducer.error,
  message: state.examinationReducer.errorMessage,
  details: state.examinationReducer.errorDetails,
});

export const selectExaminationStatus = (state: RootState) =>
  state.examinationReducer.examinationStatus;

export const selectReportSendingisLoading = (state: RootState) =>
  state.examinationReducer.loading;

export const selectReportSendingisSucceeded = (state: RootState) =>
  state.examinationReducer.succeededMail;

export const selectReportSendingisFinished = (state: RootState) =>
  state.examinationReducer.finished;

export const selectReportRemainingResends = (state: RootState) =>
  state.examinationReducer.remainingResends;

export const selectExaminationResult = (state: RootState) =>
  state.examinationReducer.examinationResult;

export const selectExaminationResultStatus = (state: RootState) =>
  state.examinationReducer.examinationResultStatus;
